/**
 * Created by jonas on 2021-02-09.
 */
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {
    SimpleReelModel,
    SimpleReelModelEventData,
    SimpleReelModelState
} from "../../core/reel/simplereel/SimpleReelModel";
import {Possessed} from "../Possessed";
import {PossessedSymbol, PossessedSymbolStates} from './PossessedSymbol';
import {PossessedGameAssets} from "../PossessedGameAssets";
import {PossessedStatics} from '../config/PossessedStatics';
import {TimelineSprite} from "@nolimitcity/promo-panel/bin/utils/TimelineSprite";
import {PossessedReelCrossView} from "../view/PossessedReelCrossView";
import { PossessedSymbolFactory } from "./PossessedSymbolFactory";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {PossessedSymbolsView} from "../view/PossessedSymbolsView"
import {gsap} from "gsap"
import {PossessedWildSymbol} from "./PossessedWildSymbol";
import {PossessedWinFireView} from "../view/PossessedWinFireView";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {WinData} from "../server/PossessedData";
import {reelPosition} from "../server/PossessedModel";

export class PossessedReelsView extends PIXI.Container implements StageLayer {

    public reelModels:SimpleReelModel[];
    private reelDarkenLayers:PIXI.Sprite[] = [];

    public mainView:PIXI.Container;

    private reelFrame:PIXI.Sprite;
    public  reelCross:PossessedReelCrossView;

    // Wilds spinning in will have be on top of mystery reels so we move them to this container
    public wildSymbolsView:PossessedSymbolsView = new PossessedSymbolsView(true, true);
    private scatterReelAnticipation:PIXI.spine.Spine;

    public scatterSymbolsView:PossessedSymbolsView = new PossessedSymbolsView(true, true);

    //public winContainer:PIXI.Container = new PIXI.Container();
    public winSymbolsView:PossessedSymbolsView = new PossessedSymbolsView();

    // I swear to god the z-layering in this game...
    private wildExpandAnticipationParticles:PIXI.spine.Spine;

    private batsTimeline:gsap.core.Timeline = gsap.timeline();
    private batsAnimation:PIXI.spine.Spine;

    // In order to keep the +1 Spin popup on top of everything we keep the animation here
    private extraSpinAnimation:PIXI.spine.Spine;
    // We also want the activator light animation when it lands to be on top of everything...
    private activatorLandAnim:PIXI.spine.Spine;


    public fullScreenM1:PIXI.spine.Spine;
    public fullScreenTransition:PIXI.spine.Spine;

    public winFireView:PossessedWinFireView = new PossessedWinFireView();

    private symbolWidth:number = PossessedStatics.SYMBOL_WIDTH;
    private symbolHeight:number = PossessedStatics.SYMBOL_HEIGHT;
    public static stepDuration:number = PossessedStatics.spinStepDuration;
    public static reelStopDelay:number =  PossessedStatics.reelStopDelay;
    public static reelStopDelayFastSpin:number =  PossessedStatics.reelStopDelayFastSpin;

    // In order to make scatters appear less frequent we triple the regular symbols but keep only 1 scatter symbol in the reelsets.
    // There might be a better solution to this...
    private static DEFAULT_REEL_SET:string[] = ["L1","L2","L3","L4","L5","M1","M2","M3","M4","M5", "S", "L1","L2","L3","L4","L5","M1","M2","M3","M4","M5", "L1","L2","L3","L4","L5","M1","M2","M3","M4","M5"];
    private static MIDDLE_REEL_SET:string[] = ["L1","L2","L3","L4","L5","M1","M2","M3","M4","M5", "S", "W", "L1","L2","L3","L4","L5","M1","M2","M3","M4","M5", "L1","L2","L3","L4","L5","M1","M2","M3","M4","M5"];

    constructor() {
        super();
        this.mainView = new PIXI.Container();
        this.addChild(this.mainView);

        this.wildExpandAnticipationParticles = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_EXPAND_BLACK_PARTICLE));
        this.wildExpandAnticipationParticles.position.set(360, 360);
        this.wildExpandAnticipationParticles.visible = false;
        this.mainView.addChild(this.wildExpandAnticipationParticles);

        this.batsAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.WILD_EXPAND_BLACK_PARTICLE));
        this.batsAnimation.position.set(360, 360);
        this.batsAnimation.visible = false;
        this.mainView.addChild(this.batsAnimation);

        this.reelFrame = new PIXI.Sprite(Possessed.assetLoader.getTextures(PossessedGameAssets.REEL_FRAME)[0]);
        this.reelFrame.anchor.set(0.5, 0.5);
        this.reelFrame.position.set(360, 340);
        this.mainView.addChild(this.reelFrame);

        this.reelCross = new PossessedReelCrossView();

        //this.winContainer.position.set(0, 152);

        this.reelModels = [];
        for (let i:number = 0; i < 5; i++){

            const reel = new SimpleReelModel(i, true);
            reel.position.set(0, 152);
            this.reelModels.push(reel);

            const reelSet = i == 2 ? PossessedReelsView.MIDDLE_REEL_SET : PossessedReelsView.DEFAULT_REEL_SET;

            reel.setReelSet(reelSet);
            reel.stepDuration = PossessedReelsView.stepDuration;
            reel.stepSize = this.symbolHeight;

            if (i == 0 || i == 4) {
                reel.paddingConfig.visibleSymbols = 3;
                reel.position.set(0, 152 + PossessedStatics.SYMBOL_HEIGHT * 2);
            } else {
                reel.paddingConfig.visibleSymbols = 6;
                reel.position.set(0, 152);
            }

            const isRestore = (Possessed.model.initData && Possessed.model.isRestore);
            const initSymbols = isRestore ? ["M1", ...Possessed.model.data.reels[i].concat(), "M1"] : Possessed.model.data.reels[i].concat();
            reel.init(initSymbols);

            const darkenLayer = new PIXI.Sprite(PIXI.Texture.WHITE);
            darkenLayer.tint = 0x000000;
            darkenLayer.alpha = 0;
            darkenLayer.position.y = reel.position.y - PossessedStatics.SYMBOL_HEIGHT/2;
            darkenLayer.position.x = PossessedStatics.SYMBOL_WIDTH * i;
            darkenLayer.width = PossessedStatics.SYMBOL_WIDTH;
            darkenLayer.height = PossessedStatics.SYMBOL_HEIGHT * reel.paddingConfig.visibleSymbols;
            this.reelDarkenLayers.push(darkenLayer);

            this.mainView.addChild(reel);
            this.mainView.addChild(darkenLayer);
        }

        //this.reelCross = new PIXI.Sprite(Exorcism.assetLoader.getTextures(ExorcismGameAssets.REEL_CROSS)[0]);
        //this.reelCross.name = "Reel Cross";
        //this.reelCross.anchor.set(0.5, 0.5);
        //this.reelCross.position.set(360, 400);
        //this.mainView.addChild(this.winContainer);
        this.mainView.addChild(this.scatterSymbolsView);
        this.mainView.addChild(this.winSymbolsView);
        this.mainView.addChild(this.reelCross);

        this.scatterReelAnticipation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_REEL_ANTICIPATION_SPINE));
        this.scatterReelAnticipation.visible = false;
        this.mainView.addChild(this.scatterReelAnticipation);

        this.reelCross.wildSymbolsContainer.addChild(this.wildSymbolsView);

        const fullScreenMask = new PIXI.Graphics;
        fullScreenMask.beginFill();
        fullScreenMask.drawRect(
            0,
            152 + PossessedStatics.SYMBOL_HEIGHT*1.5,
            (PossessedStatics.SYMBOL_WIDTH * 7),
            PossessedStatics.SYMBOL_HEIGHT*3
        );
        fullScreenMask.drawRect(
            PossessedStatics.SYMBOL_WIDTH,
            152 - PossessedStatics.SYMBOL_HEIGHT/2,
            PossessedStatics.SYMBOL_WIDTH * 3,
            PossessedStatics.SYMBOL_HEIGHT * 6
        );
        fullScreenMask.endFill();

        this.extraSpinAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.SCATTER_ANIMATION));
        this.extraSpinAnimation.visible = false;
        this.mainView.addChild(this.extraSpinAnimation);

        this.activatorLandAnim = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset(PossessedGameAssets.ACTIVATOR_SYM_SPINE));
        this.activatorLandAnim.alpha = 0;
        this.mainView.addChild(this.activatorLandAnim);

        this.fullScreenM1 = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/M1_cross.json"));
        this.fullScreenM1.mask = fullScreenMask;
        this.fullScreenM1.position.set(360, 366);
        this.fullScreenM1.visible = false;
        this.addChild(fullScreenMask);

        this.fullScreenTransition = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/transition_fire.json"));
        this.fullScreenTransition.position.set(360, 385);
        this.fullScreenTransition.visible = false;

        //this.fullScreenM1.position.y += PossessedStatics.SYMBOL_HEIGHT/2;
        //this.fullScreenM1.visible = false;

        this.mainView.addChild(this.fullScreenM1, this.fullScreenTransition);
        this.mainView.addChild(this.winFireView);
    }

    createSymbol(symbolName:string, state:SimpleReelModelState, reelID:number, reelPosition:number):PossessedSymbol {
        let symbolState:PossessedSymbolStates = PossessedSymbolStates.NORMAL;
        switch (state) {
            case SimpleReelModelState.SPIN:
                symbolState = PossessedSymbolStates.SPIN;
                break;
            case SimpleReelModelState.STOP:
                symbolState = PossessedSymbolStates.STOP;
                break;
            default:
                symbolState = PossessedSymbolStates.NORMAL;
                break;
        }
        const symbol = PossessedSymbolFactory.createSymbol(symbolName, reelID, reelPosition, symbolState);
        symbol.position.x = reelID * this.symbolWidth + (PossessedStatics.SYMBOL_WIDTH/2.0);
        symbol.position.y = this.symbolHeight * reelPosition;
        if(symbolName == "W") {
            this.wildSymbolsView.addSymbol(symbol);
        } else {
            this.reelModels[reelID].addChild(symbol);
        }

        //if (reelID == 0 || reelID == 4) {
        //    this.sideSymbolContainer.addChild(symbol);
        //} else {
        //    this.centerSymbolContainer.addChild(symbol);
        //}
        return symbol;
    }

    removeSymbol(symbol:PossessedSymbol):void {
        symbol.destroy();
    }

    getVisibleSymbolAt(column:number, row:number) {
        const visibleSymbols = this.reelModels[column].getAllVisibleStopSymbols();
        return visibleSymbols[row];
    }

    getSymbolAt(column:number, row:number) {
        return this.reelModels[column].symbols.find((sym) => sym.reelPosition == row)!;
    }

    getAllVisibleSymbols():PossessedSymbol[] {
        return <PossessedSymbol[]>this.reelModels
            .map((reel) => reel.getAllVisibleSymbols())
            .reduce((a,b) => a.concat(b), []);
    }

    setSymbolAt(column:number, row:number, newSym:PossessedSymbol) {
        this.reelModels[column].replaceSymbolAt(row, newSym);
        newSym.reelID = column;
        newSym.reelPosition = row;
        newSym.position.x = column * this.symbolWidth + this.symbolWidth*0.5;
        newSym.position.y = this.symbolHeight * row;
    }

    replaceSymbolAt(column: number, row: number, newSym:PossessedSymbol):void {
        const oldSymbol = this.getSymbolAt(column, row);
        this.setSymbolAt(column, row, newSym)
        this.removeSymbol(oldSymbol);
    }

    playReelDarkening(reelID:number, duration:number = 0.3):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.reelDarkenLayers[reelID], {alpha: 0.7, duration: duration}))
    }
    playReelUndarken(reelID:number, duration:number = 0.3):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.reelDarkenLayers[reelID], {alpha: 0, duration: duration}));
    }

    removeAllReelDarkening() {
        this.reelDarkenLayers.forEach(darken => darken.alpha = 0);
    }

    showIndividualWins(winData:WinData, fadeDuration:number = 0.5):gsap.core.Timeline {
        const tl = gsap.timeline();

        const winTexts:PIXI.Container[] = [];

        const usedPositions:reelPosition[] = [];

            const lineTL = gsap.timeline();

            const container = new PIXI.Container;
            const winAmountText = Possessed.apiPlugin.currency.formatValue(winData.winLineData.multipliedAmount);
            const amountText = new PIXI.BitmapText(winAmountText, {
                fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 18
            });
            amountText.anchor = 0.5;
            const lastWinningPos = winData.winningPositions.filter(pos => pos.reelID == winData.winLineData.length-1)[0];
            const lastWinningSymbol = this.getSymbolAt(lastWinningPos.reelID, lastWinningPos.reelPosition);
            // Last symbols should never be on the first reel but we check just in case
            const lastSymbolAtSideReel = lastWinningSymbol.reelID == 0 || lastWinningSymbol.reelID == 4;
            container.position.copyFrom(lastWinningSymbol.position);
            container.position.y -= 30;
            const additionalOffsetY = usedPositions.filter(pos => pos.reelPosition == lastWinningPos.reelPosition && pos.reelID == lastWinningPos.reelID).length * -60;
            container.position.y += additionalOffsetY + (lastSymbolAtSideReel ? (152 + PossessedStatics.SYMBOL_HEIGHT*2) : 152);

            const waysText = new PIXI.BitmapText(winData.winLineData.numberOfCombinations.toString(), {
                fontName: PossessedGameAssets.BITMAP_FONT_WIN_COUNT_UP,
                fontSize: 13
            });
            //waysText.anchor = 0.5;

            const waysContainer = new PIXI.Container;

            const waysImage = new PIXI.Sprite(Possessed.assetLoader.getTextures(waysText.text == "1" ? "Way" : "Ways")[0]);
            waysImage.scale.set(0.3, 0.3);
            waysImage.position.set(
                waysText.width,
                0
            );
            waysContainer.addChild(waysText);
            waysContainer.addChild(waysImage);
            waysContainer.position.y = 30;
            waysContainer.position.x -= waysContainer.width/2;

            container.addChild(amountText);
            container.addChild(waysContainer);

            winTexts.push(container);
            usedPositions.push({reelID: lastWinningPos.reelID, reelPosition: lastWinningPos.reelPosition});

            lineTL.add(() => {
                this.addChild(container);
            });
            lineTL.add(gsap.to(container.position, {y: container.position.y - 50, duration: fadeDuration}));
            lineTL.add(gsap.to(container, {alpha: 0, duration: fadeDuration}), "<");
            tl.add(lineTL, 0);

        tl.add(() => {
            winTexts.forEach(text => {
                this.removeChild(text);
                text.destroy({children: true});
            })
        })
        return tl;
    }

    playScatterReelAnticipation(reelID:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(()=> {
                SpineGSAPWrapper.resetSpineState(this.scatterReelAnticipation);
                this.scatterReelAnticipation.position.x = PossessedStatics.SYMBOL_WIDTH * reelID + PossessedStatics.SYMBOL_WIDTH / 2;
                if(reelID == 0 || reelID == 4) {
                    this.scatterReelAnticipation.scale.set(1, 0.75);
                    this.scatterReelAnticipation.position.y = 152 + (PossessedStatics.SYMBOL_HEIGHT * 3);
                } else {
                    this.scatterReelAnticipation.scale.set(1, 1);
                    this.scatterReelAnticipation.position.y = 152 + (PossessedStatics.SYMBOL_HEIGHT * 2.5);
                }
            })
            .add(SpineGSAPWrapper.createTimeline(this.scatterReelAnticipation, 0, "x6Height", 0))
            .add(()=>{this.scatterReelAnticipation.visible = false})
    }

    playGreenAnticipationEffect():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.reelCross.wildReelAnticipation);
                this.reelCross.wildReelAnticipation.state.setAnimation(0, "main", true);
            })
    }
    stopGreenAnticipationEffect(fadeDur:number = 0.1):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.reelCross.wildReelAnticipation, {alpha: 0, duration: fadeDur}))
            .add(() => {
                this.reelCross.wildReelAnticipation.visible = false;
                this.reelCross.wildReelAnticipation.alpha = 1;
            })
    }

    public playWildAnticipationEffects():gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.wildExpandAnticipationParticles);
                this.wildExpandAnticipationParticles.state.setAnimation(0, "loop", true);
            })
            .add(this.reelCross.playWildExpandAnticipation(), "<")
    }

    public fadeOutWildExpandAnticipationEffects(fadeOutDur:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(gsap.to(this.wildExpandAnticipationParticles, {alpha: 0, duration: fadeOutDur}))
            .add(this.reelCross.fadeOutWildExpandAnticipation(fadeOutDur), "<")
            .add(() => {
                this.wildExpandAnticipationParticles.visible = false;
                this.wildExpandAnticipationParticles.alpha = 1;
            })
    }

    public playFullScreenM1():gsap.core.Timeline {
        const tl = gsap.timeline();
        tl.add(() => {
            this.fullScreenM1.alpha = 0;
            SpineGSAPWrapper.resetSpineState(this.fullScreenM1);
            SpineGSAPWrapper.resetSpineState(this.fullScreenTransition);
            this.fullScreenM1.state.setAnimation(0, "m1_full", true)
        })
        tl.add(SpineGSAPWrapper.createTimelineForAnimation(this.fullScreenTransition, 0, "transition"));
        tl.add(gsap.to(this.fullScreenM1, {alpha: 1, duration: 0.2}), "<0.5")
        return tl;
    }

    public hideFullScreenM1(fadeDur:number = 0.1):gsap.core.Timeline {
        if(this.fullScreenM1.visible) {
            return gsap.timeline()
                .add(gsap.to(this.fullScreenM1, {alpha: 0, duration: fadeDur}))
                .add(() => {
                    this.fullScreenM1.visible = false;
                    this.fullScreenTransition.visible = false;
                })
        } else {
            return gsap.timeline();
        }
    }

    public playBatsEffectCenter():void {
        this.batsTimeline.kill();
        this.batsTimeline = gsap.timeline()
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.batsAnimation);
            })
            .add(SpineGSAPWrapper.createTimeline(this.batsAnimation, 0, "center"))
    }

    public playExtraSpinPopup(reelID:number, reelPos:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                const additionalHeightOffset = (reelID == 0 || reelID == 4) ? (PossessedStatics.SYMBOL_HEIGHT*2) : 0;
                this.extraSpinAnimation.position.set(
                    (PossessedStatics.SYMBOL_WIDTH * reelID) + (PossessedStatics.SYMBOL_WIDTH/2),
                    additionalHeightOffset + 152 + (PossessedStatics.SYMBOL_HEIGHT * reelPos)
                );
                SpineGSAPWrapper.resetSpineState(this.extraSpinAnimation);
            })
            .add(SpineGSAPWrapper.createTimelineForAnimation(this.extraSpinAnimation, 0, "s1fssfs"))
            .add(() => {
                this.extraSpinAnimation.visible = false;
            })
    }

    public playActivatorLand(reelID:number, reelPos:number):gsap.core.Timeline {
        return gsap.timeline()
            .add(() => {
                const additionalHeightOffset = (reelID == 0 || reelID == 4) ? (PossessedStatics.SYMBOL_HEIGHT*2) : 0;
                this.activatorLandAnim.position.set(
                    (PossessedStatics.SYMBOL_WIDTH * reelID) + (PossessedStatics.SYMBOL_WIDTH/2),
                    additionalHeightOffset + 152 + (PossessedStatics.SYMBOL_HEIGHT * reelPos)
                );
                //SpineGSAPWrapper.resetSpineState(this.activatorLandAnim);
                this.activatorLandAnim.alpha = 1;
            })
            .add(SpineGSAPWrapper.createTimeline(this.activatorLandAnim, 0, "light"))
            .add(() => {
                SpineGSAPWrapper.resetSpineState(this.activatorLandAnim);
                this.activatorLandAnim.alpha = 0;
            })
    }
    public hideActivatorLandAnim() {
        this.activatorLandAnim.alpha = 0;
    }

    public onRestore() {
        const symbolSizes = Possessed.model.initData.symbolSizes;

        // Restore symbol sizes
        this.reelModels.forEach((reel, reelIndex) => {
            reel.getAllVisibleSymbols().forEach((sym, symIndex) => {
                if(symbolSizes[reelIndex][symIndex] > 1) {
                    sym.setXWays(symbolSizes[reelIndex][symIndex]);
                }
            })
        })

        // Restore expanded wild
        const wildSymbols = <PossessedWildSymbol[]>this.getAllVisibleSymbols().filter(sym => sym.name == "W");
        const fullCrossWild = wildSymbols.length == 6;
        const expandedWild = wildSymbols.length == 4;

        if(fullCrossWild) {
            wildSymbols.forEach(sym => {
                if (sym.reelID == 2 && sym.reelPosition == 3) {
                    const tl = gsap.timeline();
                    tl.add(sym.expandFullCross());
                    tl.progress(1);
                    sym.isExpandedWild = true;
                    this.wildSymbolsView.addSymbol(sym);
                } else {
                    sym.visible = false;
                    sym.isExpandedWild = true;
                }
            })
        } else if(expandedWild) {
            wildSymbols.forEach(sym => {
                if (sym.reelID == 2 && sym.reelPosition == 3) {
                    const tl = gsap.timeline();
                    tl.add(sym.expandUp());
                    tl.progress(1);
                    sym.isExpandedWild = true;
                    this.wildSymbolsView.addSymbol(sym);
                } else {
                    sym.visible = false;
                    sym.isExpandedWild = true;
                }
            })
        }

    }
}